import { Box } from '@mui/material';
import React from 'react';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export class TabPanel extends React.Component<TabPanelProps> {
    public render(): React.ReactNode {
        const { children, value, index, ...other } = this.props;

        return (
            <div
                role='tabpanel'
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box className='mt-3'>{children}</Box>}
            </div>
        );
    }
}
